{
  "version": 1,
  "source": "docs/references/maps/De_Groote_Kaart_van_Amsterdam_in_1544_by_Cornelis_Anthonisz.jpg",
  "sourceSize": [8738, 8595],
  "notes": "The Begijnhof's row between its court and the Nieuwezijds Voorburgwal, as the 1544 woodcut draws it: one unbroken row of narrow two-storey fronts, each behind a small fenced plot, from beside the chapel to the Sint Luciënklooster. Carried to the layout by the woodcut's registration (docs/woodcut-ground.md), eight fronts stand along the 42 m of the court's path and four beside the chapel, a fifth running on beyond them. The count of fronts and the two stepped gables read among the eight and one among the five are observations; at about 17 px a front the gable of a single house is uncertain. Equal frontages, the 10 m depth, two storeys and tile roofs are estimates: the facsimile's colouring is later than 1544 and is no evidence of roof material. The fronts face the court, as the hof's houses do; the woodcut turns every front toward its viewer and does not show this. The fenced plots before the houses are not modelled. The woodcut draws the row and the court some 25 m further north than the path runs, on ground the layout gives the Sint Luciënklooster. See docs/woodcut-ground.md, The Begijnhof.",
  "rows": [
    {
      "id": "begijnhof-west",
      "source": "street-begijnhof",
      "side": "left",
      "from": 0.5,
      "to": 42,
      "depth": 10,
      "evidence": "painted",
      "houses": [
        {
          "id": "begijnhof-west-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "stepped"
        },
        {
          "id": "begijnhof-west-02",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "begijnhof-west-03",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "stepped"
        },
        {
          "id": "begijnhof-west-04",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "begijnhof-west-05",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "begijnhof-west-06",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "begijnhof-west-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "begijnhof-west-08",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        }
      ]
    },
    {
      "id": "begijnhof-chapel-side",
      "source": "street-begijnhof-2",
      "side": "right",
      "from": 46,
      "to": 72,
      "depth": 10,
      "evidence": "painted",
      "houses": [
        {
          "id": "begijnhof-chapel-side-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "begijnhof-chapel-side-02",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "stepped"
        },
        {
          "id": "begijnhof-chapel-side-03",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "begijnhof-chapel-side-04",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "begijnhof-chapel-side-05",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        }
      ]
    }
  ]
}
